import { Paragraph, styled } from 'tamagui'

export const FormHelpText = styled(Paragraph, {
  size: '$5',
  color: '$black11',
})
